import { render, staticRenderFns } from "./GlobalSourceFilter.vue?vue&type=template&id=21e1090a&scoped=true"
import script from "./GlobalSourceFilter.vue?vue&type=script&lang=js"
export * from "./GlobalSourceFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1090a",
  null
  
)

export default component.exports